export default __webpack_public_path__ + "static/media/job_centrum_logo.16349502.svg";